import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c4bf1e58")

_pushScopeId("data-v-c4bf1e58")
const _hoisted_1 = { class: "mb-n8 table-scroll-x" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loader,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Table, {
        columns: _ctx.columns,
        rows: _ctx.customersProducts,
        padding: 5,
        pagination: _ctx.pagination,
        fluid: "",
        onHandleCurrentChange: _ctx.handleCurrentChange
      }, {
        "cell-user_name": _withId(({row:item}) => [
          _createTextVNode(_toDisplayString(item?.customer?.user?.name), 1)
        ]),
        "cell-name": _withId(({row:item}) => [
          _createTextVNode(_toDisplayString(JSON.parse(item?.product?.description?.name)?.[`${_ctx.system_locale}`]?.name), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange"])
    ])
  ], 64))
})